import * as React from 'react';
import {
  Grid, Box, Divider, Card, CardContent,
  Typography,
} from '@material-ui/core';
import RepairInformation from '../metalCollection/RepairInformation';
import RepairJobContainer from '../packer/RepairJobContainer';
import type { IRepairItem } from '../marking/MarkingInterfaces';

interface IJewelerRepairItemDisplayProps {
  repairItems: IRepairItem[],
  showExtraProps?: boolean,
}

const JewelerRepairItemDisplay: React.FC<IJewelerRepairItemDisplayProps> = ({ repairItems, showExtraProps = false }) => {
  const RepairItemMap = (
    repairItems?.map((repairItem:IRepairItem) => (
      <Grid item xs={12}>
        <Card>
          <Box ml={2} my={2}>
            <Typography variant="h5" style={{ fontSize: '1.125rem', color: '#587B9F' }}>{repairItem?.label || repairItem?.jewelryType?.label || repairItem?.repairItemType?.label}</Typography>
          </Box>
          <Divider />
          <CardContent style={{ backgroundColor: '#F5F5F5' }}>
            <Grid container spacing={3}>
              {
                repairItem?.repairItemJobs && repairItem?.repairItemJobs?.length >= 1
                && (
                  <Grid item xs={12} md={6}>
                    <RepairJobContainer title="Repair Jobs" repairItem={repairItem} />
                  </Grid>
                )
              }
              <Grid item xs={12} md={6}>
                <RepairInformation RepairItem={repairItem} showExtraProps={showExtraProps} />
              </Grid>
              <Grid item xs={12} md={6}>
                <Box p={2} />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    ))
  );

  return (
    <>
      { RepairItemMap }
    </>
  );
};

export default JewelerRepairItemDisplay;
